export default __webpack_public_path__ + "static/media/single-project-page-04-img04.dd6323a8.jpg";